import {
    provideTransloco,
    TranslocoModule,
} from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-loader';
import { environment } from '../environments/environment';

@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: {
                availableLangs: ['en', 'da', 'fr', 'ja', 'nb', 'nl', 'sv', 'es', 'pt'],
                defaultLang: 'en',
                fallbackLang: 'en',
                reRenderOnLangChange: true, // changing language in runtime
                prodMode: environment.production,
                missingHandler: {
                    logMissingKey: false,
                    useFallbackTranslation: true,
                },
            },
            loader: TranslocoHttpLoader,
        }),
    ],
})
export class TranslocoRootModule {}
